import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=22549ff6&scoped=true&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=22549ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22549ff6",
  null
  
)

export default component.exports